<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        {{$route.query.id?$route.query.view?'文物档案':'修改文物档案':'新增文物档案'}}
      </div>
    </div>

    <!-- 基本信息 -->

    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      :rules="rules"
      class="mt20"
    >
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item
            label="文物名称"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
            prop="relicName"
          >
            <el-input v-model="form.relicName"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            label="类别"
            prop="type"
            style="width: 100%"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
          >
            <!-- v-model="form.wenwuBasicInformation.tenure" -->
            <el-select v-model="form.type">
              <el-option :value="1" label="古建筑"></el-option>
              <el-option
                :value="2"
                label="近现代重要史迹及代表性建筑"
              ></el-option>
              <el-option :value="3" label="古墓葬"></el-option>
              <el-option :value="4" label="石窟寺及石刻"></el-option>
              <el-option :value="5" label="古遗址"></el-option>
              <el-option :value="6" label="其它"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="级别"
            prop="relicRank"
            style="width: 100%"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
          >
            <!--  -->
            <el-select v-model="form.relicRank">
              <el-option :value="1" label="全国重点"></el-option>
              <el-option :value="2" label="省级"></el-option>
              <el-option :value="3" label="青岛市级"></el-option>
              <el-option :value="4" label="平度市级"></el-option>
              <el-option :value="5" label="尚未定级"></el-option>
            </el-select>
            <!-- <el-input v-model="form.wenwuBasicInformation.tenure"></el-input> -->
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="位置"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
            prop="position"
          >
            <!-- v-model="form.wenwuBasicInformation.useStatus" -->
            <el-input v-model="form.position"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            label="年代"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
            prop="age"
          >
            <!-- v-model="form.wenwuBasicInformation.address" -->
            <el-input v-model="form.age"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
          label-width="150px"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
            label="公布时间及批次"
            prop="publicationTimeBatch"
          >
            <!--  -->
            <el-input v-model="form.publicationTimeBatch"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="标志碑"
            :rules="{
              message: '请选择',
              trigger: 'change',
              required: true,
            }"
            prop="markerTablet"
          >
            <el-radio v-model="form.markerTablet" :label="1">有</el-radio>
            <el-radio v-model="form.markerTablet" :label="0">无</el-radio>
          </el-form-item>
        </el-col>
      
      </el-row>
      <el-row :gutter="24">
          <el-col :span="8">
          <el-form-item label="产权" prop="equity" style="width: 100%">
            <!--  -->
            <el-select v-model="form.equity">
              <el-option :value="1" label="国有"></el-option>
              <el-option :value="2" label="部队"></el-option>
              <el-option :value="3" label="集体"></el-option>
              <el-option :value="4" label="个人"></el-option>
              <el-option :value="5" label="教会"></el-option>
              <el-option :value="6" label="其他"></el-option>
            </el-select>
            <!-- <el-input v-model="form.wenwuBasicInformation.tenure"></el-input> -->
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="使用人" prop="user">
            <!--  -->
            <el-input v-model="form.user"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="150px" label="文物安全直接责任人" prop="safetyPerson">
            <!-- v-model="form.wenwuBasicInformation.stairsStructure" -->
            <el-input v-model="form.safetyPerson"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="镇级联系人" prop="townContact">
            <!-- -->

            <el-input v-model="form.townContact"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="natureId!=2">
            <el-form-item
              label="街道/镇"
              prop="userId"
              style="width: 100%"
              :rules="{
                message: '请填写/选择',
                trigger: 'change',
                required: true,
              }"
            >
              <el-select v-model="form.userId" @change="huoqudanwei">
                <el-option
                  v-for="item in jiedao"
                  :value="item.userId"
                  :label="item.nickName"
                ></el-option>
                <!-- <el-option value="1" label="通过"></el-option>
                <el-option value="2" label="驳回"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
        <el-col :span="8" v-if="natureId!=2">
            <el-form-item
              label="单位"
              prop="companyNumber"
              style="width: 100%"
             
            >
            <!--  -->
              <el-select v-model="form.companyNumber" @change="$forceUpdate()" clearable	>
                <el-option
                  v-for="item in chanxunform1Com"
                  :value="item.companyNumber"
                  :label="item.companyName"
                ></el-option>
                <!-- <el-option value="1" label="通过"></el-option>
                <el-option value="2" label="驳回"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
      </el-row>
      <el-row class="mt10">
        <el-col :span="24">
          <el-form-item label="保护范围" prop="rangeProtection"  :rules="{
              message: '请选择',
              trigger: 'change',
              required: true,
            }">
            <el-input type="textarea" v-model="form.rangeProtection" :rows="6"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt10">
        <el-col :span="24">
          <el-form-item label="建设控制地带" prop="constructionZone"  :rules="{
              message: '请选择',
              trigger: 'change',
              required: true,
            }">
            <el-input
            :rows="6"
              type="textarea"
              v-model="form.constructionZone"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt10">
        <el-col :span="24">
          <el-form-item label="简介" prop="intro"  :rules="{
              message: '请选择',
              trigger: 'change',
              required: true,
            }">
            <el-input :rows="6" type="textarea" v-model="form.intro"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <div class="tab-hr">
        <span></span>
        <div class="flex1 ml10">其他附件</div>
      </div> -->
      <el-row class="mt10">
        <el-col :span="24">
          <el-form-item label="照片" prop="existProblems">
            <div class="flex">
              <!-- <span>上传照片:</span> -->

              <fileUpload
                v-model="form.picture"
                :uploadData="{ flagType: '0' }"
                :fileType="['png', 'jpeg', 'jpg']"
                :fileUrl="'/oss/file/uploadFileFlag'"
                :fileSize="10"
                :limit="10"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt10">
        <el-col :span="12">
          <el-form-item label="附件名" prop="existProblems">

                     <!-- :disabled="fileChecking || $route.query.view" -->
         
            <el-upload
              class="upload-demo"
              drag
              action="."
         
              :before-upload="beforeUpload"
              :http-request="
                (file) => {
                  return upload(file, 'wenwuAttachmentList', 'attachmentUrl');
                }
              "
              :on-remove="handleRemoveAttachment"
              multiple
              list-type="text"
              :file-list="it"
              :limit="5"
              :fileSize="10"
              :show-file-list="true"
              :on-exceed="handleExceed"
              v-model="form.attachments"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>,最多上传5个文件<span
                  class="rulesColor"
                  >支持pdf, doc,
                  docx,txt,excel等格式文件上传，文件大小不超过10MB</span
                >
              </div>
            </el-upload>
           
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item>
             <div v-for="(item, index) in huixianFile">
              <div style="display:flex">
                <span>{{item}}</span> <img src="@/assets/img/file.png"  style="width: 40px; height: 40px" />
                <el-button type="text" class="ml10" @click="uplod(index)" >下载</el-button>
                <el-button el-button type="text" class="ml10" @click="handleDelete(index)" >删除</el-button>
              </div>
               
            </div>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row v-if="form.turnDown">
        <el-col>
          <el-form-item>
             <h3 class="bohuisty">驳回理由：{{form.turnDown}}</h3>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!--四有档案  -->
    <!-- <div v-if="nowIndex == 4" style="height: 750px; width: 100%">
      <iframe width="100%" height="100%" :src="siyouUrl" frameborder="0" class="flex1"></iframe>
    </div> -->
    <div class="center">
      <el-button
        class="l-btn"
        type="primary"
        @click="onSubmit"
        v-hasPermi="['archives:relicInspectionArchives:addAndUpdate']"
        v-if="!$route.query.view"
      >
        保存
      </el-button>
      <el-button class="l-btn ml20" type="primary" @click="$router.back(-1)"
        >返回</el-button
      >
        <el-button
        class="l-btn"
        type="success"
        @click="onSubmit"
        v-hasPermi="['archives:relicInspectionArchives:pass']"
        v-if="!$route.query.view&&form.status==0"
      >
        审核通过
      </el-button>
      <el-button v-hasPermi="['archives:relicInspectionArchives:turnDown']" class="l-btn ml20" type="info" @click="$router.back(-1)" v-if="!$route.query.view&&form.status==0"
        >审核驳回</el-button
      >
    </div>

  </div>
</template>

<script>
import OSS from "ali-oss";
export default {
  data() {
    return {
      // cNum:''||this.$store.state.user.company.cCompanyNum||this.$local.get("company").c_company_num,
      form: {
        companyNum: this.$store.state.user.company.cCompanyNum||'',
        age: "",
        approvalTime: "",
        approvalUser: "",
        attachments: "",
        constructionZone: "",
        createTime: "",
        delFlag: null,
        equity: null,
        id: null,
        intro: "",
        markerTablet: null,
        photo: "",
        position: "",
        publicationTimeBatch: "",
        rangeProtection: "",
        relicName: "",
        relicRank: null,
        remark: "",
        safetyPerson: "",
        status: null,
        townContact: "",
        turnDown: "",
        type: null,
        updateTime: "",
        user: "",
      },
      jiedao:{},
      jiedaoCopy:{},
      chanxunform1Com:{},
      chanxunform1ComCopy:{},
      rules: {},
      radio: "1",
      fileList: {},
      fileChecking: false,
      it: [],
      id:null,
      files: [],
      huixianFile:[],
      init:true,
      natureId:null
    };
  },
 created() {
 
    // if (this.$store.state.user.userInfo.natureId=2&&this.$local.get('company').c_company_num) {
    //   this.huoqudanwei()
    // }
    // console.log(this.$route.query.id,'this.$router.query.id');
    // this.getList()
  },
  mounted(){
       console.log(this.$store.state.user.userInfo.natureId,'11111122222')
       this.natureId=JSON.parse(localStorage.getItem('userInfo')).natureId
    // this.natureId=this.locals.get('userInfo').natureId
    this.id=this.$route.query.id

    this.getCom(true,0)
        if (this.id) {
      this.form.id=Number(this.id) 
     this.getDetail()
    }
  },
  methods: {
    handleExceed(){
      this.$message.error(`上传文件数量不能超过5个!`);
    },
    getDetail(){
      this.$get('relic/relicInspectionArchives/'+this.id).then(res=>{
        console.log(res,'222222222')
        this.form=res.data
        
        if(this.form.photo){
          this.form.picture=this.form.photo
        }
        if (this.form.attachments) {
          this.files=this.form.attachments.split(',')
          this.it=JSON.parse(JSON.stringify(this.files)) 
          this.it=this.it.map(item=>{
            // console.log(item,'item');
            var index=item.lastIndexOf("\/");
            return {
              name:item.substring(index + 1, item.length),
              url:item
            }
          })
          // =this.files
          // console.log(this.files,'this.it')
        }

          this.getCom(true,1)

        
      })
    },
    getCom(falg,index) {
      this.$get('/relic/relicInspectionArchives/selectUserInfoByRole').then(res=>{
        console.log(res,333333333);
        this.jiedao=res.data
        this.jiedaoCopy=res.data
        if (this.id&&index==1) {
          this.huoqudanwei(index)
        }
        console.log(JSON.parse(localStorage.getItem('userInfo')).natureId,55555);
       if (JSON.parse(localStorage.getItem('userInfo')).natureId==2&&JSON.parse(localStorage.getItem('company')).c_company_num) {
        console.log('buhuizou ');
          this.form.userId=res.data[0].userId
          this.huoqudanwei()
     
        
        }
       
      })
      
    },
    huoqudanwei(index){
      console.log(index,'222222222');
      // console.log(this.form.userId,index,'this.form.userId');
      if (index==1) {
          this.form.companyNumber=this.form.companyNum
          
      }else{
          this.form.companyNumber=''
          this.form.companyNum=''
      }
      // if(this.id&&this.init){
      //   this.form.companyNumber=this.form.companyNum
      //     this.init=false
      //   console.log('zou');
      //     console.log(this.form.companyNumber,8888); 


      // }else{
      //     this.form.companyNumber=''
      //     this.form.companyNum=''
      // }
      console.log(this.form.companyNumber,1111);
       this.$get("/relic/relicInspectionArchives/companyBaseByUserId/"+this.form.userId).then(
        (res) => {
          log(res, 44444);
           
          this.chanxunform1Com = res.data;
          this.chanxunform1ComCopy = res.data;
          log(this.chanxunform1Com, this.form.companyNumber,55555);

        }
      );
    },
    getList() {},
    onSubmit() {
      console.log(this.form, this.files,this.chanxunform1ComCopy,this.jiedaoCopy, "1111111111");
      this.form.companyNum=this.form.companyNumber
      this.form.photo = this.form.picture;


   if (JSON.parse(localStorage.getItem('userInfo')).natureId==2 && JSON.parse(localStorage.getItem('company')).c_company_num) {
    console.log(this.chanxunform1ComCopy.length>0);
    if (this.chanxunform1ComCopy.length>0) {
      this.form.companyNum=this.chanxunform1ComCopy[0].companyNumber
    }
     
     this.form.userId=this.jiedaoCopy[0].userId
    }
    if (JSON.parse(localStorage.getItem('userInfo')).natureId==2 &&JSON.parse(localStorage.getItem('userInfo')).roleIdListStr=='125') {
      this.form.companyNum=''
    }

      let data = this.files.map((item) => {
        if (item.url) {
          return item.url;
        }else{
         return item
        }
        
      });
      console.log(this.form,'data');
      this.form.attachments = data.join(",");
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$post(
            "/relic/relicInspectionArchives/addAndUpdate",
            this.form
          ).then((res) => {
            if (res.code==200) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
              this.$router.back()
            }
            console.log(res, 1122);
          });
        } else {
          return false;
        }
      });
    },

    beforeUpload(file) {
      // console.log(file,33333);
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error({
          message: `上传文件大小不能超过10M!`,
        });
        return false;
      }
    },


    upload(val, type, pathKey, index) {
      let client = new OSS(this.$bus.config.ossConfig);
      console.log(val, client, "client");
      let file = val.file;
      let _this = this;
      let id =
        this.$bus.config.dangan +
        "/t" +
        Date.now() +
        "s" +
        file.size +
        "/" +
        file.name;

      var fileList = null;
      this.$set(this.fileList, id, {
        name: file.name,
        size: file.size,
        uploading: true,
        uid: file.uid,

        time: 0,
        progress: 0,
        key: id,
        client: client,
        type: type,
        pathKey,
      });
      fileList = this.fileList;

      // _this.getTimes(file, id)
      // 定义上传方法。

      function multipartUpload(fileList) {
        fileList[id].client
          .multipartUpload(id, file, {
            checkpoint: fileList[id] ? fileList[id].data : null,
            progress: (p, checkpoint, res) => {
              //log(p,checkpoint,res)
              if (checkpoint) {
                fileList[id].progress = p * 100;
                fileList[id].data = checkpoint;
              }
            },
            partSize: 1000 * 1024, //设置分片大小
            timeout: 120000, //设置超时时间
            mime: val.type,
          })
          .then((res) => {
            fileList[id].progress = 100;
            fileList[id].uploading = false;

            _this.$notify({
              title: "上传成功",
              message: `${fileList[id].name}上传完成`,
              type: "success",
            });
            console.log(file.uid, "file.uid");

            if (_this.files) {
              _this.files.push({
                uid: file.uid,
                url:
                  "http://zhidui-video.oss-cn-qingdao.aliyuncs.com" + res.name,
              });
            } else {
              _this.files.push({
                uid: file.uid,
                url:
                  "http://zhidui-video.oss-cn-qingdao.aliyuncs.com" + res.name,
              });
            }
            // let str="http://zhidui-video.oss-cn-qingdao.aliyuncs.com" + res.name
            //   var index= str.lastIndexOf("\/")
            //   let huidata=str.substring(index + 1, str.length)
            //  this.huixianFile.push(huidata)
            //  =this.it.map(item=>{
            // console.log(item,'item');
            // var index=item.lastIndexOf("\/");
            // return item.substring(index + 1, item.length)
          // })

            // console.log(this.huixianFile,_this.files, res, "_thisfiles");
            // _this.form["wenwuBasicInformation"][type] =
            //   "http://zhidui-video.oss-cn-qingdao.aliyuncs.com" + res.name;

            return res.name;

            // var stobj = {tr_task_id:_this.uuid,tr_baogao_address,tr_sub_status:1,tr_shengcheng_status:1,tr_baogao_xingshi:0}
            // _this.$post('/api-b/tr/plan/baogaoaddress',stobj).then(data=>{

            //     _this.getList()
            // })
          })
          .catch((err) => {
            if (
              err.code == "RequestError" ||
              err.code == "ConnectionTimeoutError"
            ) {
              //网络错误或超时
              setTimeout(multipartUpload, 3000);
            }
          });
      }

      multipartUpload(fileList);
    },
    handleRemoveAttachment(file, fileList) {
      // console.log(file, this.files, fileList,"file, fileList");
      // if (file.uid) {
        let array= this.files.map((item) => {
          if (item.uid) {
             return item.url;
          }else{
            return item;
          }
       
      });
      // console.log(array);
      this.files=array.filter((item) => {
            return item!= file.url;
      });
      // }else{
      //    this.files = this.files.filter((item) => {
      //   return item.uid != file.uid;
      // });
      // }
      
      
      // console.log(this.files, "file11111");
    },
  },
};
</script>

<style scoped lang="scss">
.tab-hr {
  padding-left: 40px;

  display: flex;
  span {
    display: inline-block;
    background: rgb(37, 97, 239);
    width: 5px;
    margin-top: 3px;
    height: 15px;
    border-radius: 30%;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 168px;
  height: 168px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.rulesColor {
  display: block;
  color: #ccc;
  font-size: 12px;
}
.bohuisty{
  width: 100%;
  text-align: center;
  color: red;
  // font-weight: bolder;
}
</style>
